module.exports = __webpack_public_path__ + "img/entry.81859731.png";